module.exports = __webpack_public_path__ + "static/media/error.83444a80.svg";